import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import connectUI from 'redux-ui';
import IQMForm from './components/IQMForm';
import {
  updateIQM,
  requestIQM,
  navigateBack,
  clearValidationErrors,
} from 'actionCreators';
import IQMType from 'types/iqm';

class IQMEdit extends Component {
  static propTypes = {
    id: PropTypes.number,
    updateUI: PropTypes.func,
    updateIQM: PropTypes.func,
    navigateBack: PropTypes.func,
    requestIQM: PropTypes.func,
    clearValidationErrors: PropTypes.func,
    loading: PropTypes.bool,
    iqm: IQMType,
    errors: PropTypes.object,
    ui: PropTypes.object,
  }

  componentDidMount() {
    if (!this.props.iqm) {
      this.props.requestIQM(this.props.id);
    }
  }

  componentWillUnmount() {
    this.props.clearValidationErrors('IQM');
  }

  handleTabChange = (index) => {
    this.props.updateUI('activeTab', index);
  }

  handleSave = iqm => this.props.updateIQM(iqm).then(this.props.navigateBack);

  handleCancel = () => this.props.navigateBack();

  render() {
    const { ui, iqm, errors, loading } = this.props;
    return (
      !loading
        ? <IQMForm
          iqm={iqm}
          errors={errors}
          onSave={this.handleSave}
          onCancel={this.handleCancel}
          activeTab={ui.activeTab}
          onTabChange={this.handleTabChange}
        />
        : <p>Loading...</p>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const id = Number(ownProps.params.id);
  const iqm = state.iqms.details.id === id ? state.iqms.details : null;
  return {
    id,
    iqm,
    loading: !iqm || state.iqms.common.loading,
    errors: state.iqms.common.errors,
  };
};

export default connectUI()(connect(
  mapStateToProps,
  {
    requestIQM,
    clearValidationErrors,
    updateIQM,
    navigateBack,
  },
)(IQMEdit));



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/iqms/IQMEdit.jsx